import styled from "styled-components";

type ContainerType = {
    background: string;
}

type TextType = {
    color: string;
}

type ButtonType = {
    background: string;
    color: string;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerDocument = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const ContentInputDocument = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 60px;
  max-height: 60px;
`;
export const ContainerReceiveInvoice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;


export const ContentInput = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ContentDataInput = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  margin-top: 15px;
`;

export const ContentJuridicalNature = styled.div<TextType>`
  display: flex;
  height: 35px;
  width: 150px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.color};
  padding: 2px;
  margin-right: 20px;
`;


export const RadioButtonLeft = styled.button<ButtonType>`
  display: flex;
  background: ${(props) => props.background};
  align-items: center;
  justify-content: center;
  border-radius: 5px 0 0 5px;
  width: 80px;
  height: 29px;
  cursor: pointer;
  border: 0;
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => props.color};

  &:hover {
    filter: brightness(80%);
  }
`;

export const RadioButtonRight = styled.button<ButtonType>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.background};
  border-radius: 0 5px 5px 0;
  width: 80px;
  height: 29px;
  cursor: pointer;
  border: 0;
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => props.color};

  &:hover {
    filter: brightness(80%);
  }
`;

export const ContentReceiveInvoice = styled.div`
  display: flex;
  height: 35px;
  width: 150px;
  border-radius: 5px;
  padding: 2px;
  margin-right: 20px;
  align-items: center;
`;
